import PropTypes from "prop-types";
import React from "react";
import { MenuItem, DropdownButton } from "react-bootstrap";

import SettingActions from "../../actions/SettingActions";

import UserStore from "../../stores/UserStore";

const pages = [
	{ name: "/accounts", displayName: "Accounts" },
	{ name: "/transactions", displayName: "Transactions" },
	{ name: "/budget", displayName: "Budget" }
];

export default class HomepageSetting extends React.Component
{
	constructor(props)
	{
		super(props);

		this.state = HomepageSetting.getStoreState();
		this._onChange = this._onChange.bind(this);
		this.handleHomepageChange = this.handleHomepageChange.bind(this);
	}

	static getStoreState()
	{
		return {
			homepage: UserStore.getUserProfileSetting("homepage")
		};
	}

	async handleHomepageChange(pageName)
	{
		const page = pages.find(t => t.name === pageName);
		await SettingActions.updateUserProfile("Homepage", page.name);
	}

	_onChange()
	{
		this.setState(HomepageSetting.getStoreState());
	}

	componentDidMount()
	{
		UserStore.addChangeListener(this._onChange);
	}

	componentWillUnmount()
	{
		UserStore.removeChangeListener(this._onChange);
	}

	render()
	{
		const selectedPageName = this.state.homepage;
		const selectedPage = pages.find(page => page.name === selectedPageName);
		const title = (selectedPage ? selectedPage.displayName : selectedPageName) || "Default";
		let enabled = this.props.enabled;

		return (
			<DropdownButton
				onSelect={this.handleHomepageChange}
				title={title}
				id="homepageChange"
				disabled={!enabled}
			>
				{pages.map(page => {
					return (
						<MenuItem
							key={page.name}
							eventKey={page.name}
							className={page.name === selectedPageName ? "active" : ""}
						>
							{page.displayName}
						</MenuItem>
					);
				})}
			</DropdownButton>
		);
	}
}

HomepageSetting.propTypes = {
	enabled: PropTypes.bool
};



// WEBPACK FOOTER //
// ./Components/components/settings/HomepageSetting.jsx